import React from "react";

const ToggleAllCheckbox = ({ values, name, fieldUpdateHandler, defVal }) => {
    const toggleButtonStyle = {
        backgroundColor: "#4CAF50",
        color: "white",
        padding: "8px 16px",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
    };

    const handleToggleAll = (e) => {
        e.preventDefault();

        let allChecked = true;
        const inputList = document.querySelectorAll(
            `div.classToggleRoomTypesInput${name} input`,
        );

        inputList.forEach((input) => {
            allChecked = allChecked && input.checked;
        });
        const newValues = allChecked ? [] : defVal;
        fieldUpdateHandler(name, newValues);
    };

    return (
        <button style={toggleButtonStyle} onClick={handleToggleAll}>
            {values.length === defVal.length ? "Сбросить все" : "Выбрать все"}
        </button>
    );
};

export default ToggleAllCheckbox;
